/**
 * action types
 */
export const SET_BRAINTREE_CLIENT_TOKEN = 'SET_BRAINTREE_CLIENT_TOKEN';
export const SET_PAYMENT_TRANSACTION = 'SET_PAYMENT_TRANSACTION';
export const SET_MOLPAY_PAYMENT_TRANSACTION = 'SET_MOLPAY_PAYMENT_TRANSACTION';
export const SUBMIT_PAYMENT_START = 'SUBMIT_PAYMENT_START';
export const SUBMIT_PAYMENT_FAILURE = 'SUBMIT_PAYMENT_FAILURE';
export const SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
export const ENTER_PAYMENTS_PAGE_DATA_LOAD_SUCCESS =
  'ENTER_PAYMENTS_PAGE_DATA_LOAD_SUCCESS';
export const PAYMENT_METHOD_SELECTED = 'PAYMENT_METHOD_SELECTED';
export const ENTER_UPDATE_PAYMENT_METHOD_PAGE_DATA_LOAD_SUCCESS =
  'ENTER_UPDATE_PAYMENT_METHOD_PAGE_DATA_LOAD_SUCCESS';
export const UPDATE_PAYMENT_METHOD_START = 'UPDATE_PAYMENT_METHOD_START';
export const UPDATE_PAYMENT_METHOD_FAILURE = 'UPDATE_PAYMENT_METHOD_FAILURE';

export const ENTER_THANK_YOU_PAGE_DATA_LOAD_SUCCESS =
  'ENTER_THANK_YOU_PAGE_DATA_LOAD_SUCCESS';
export const ENTER_PAYMENT_PAGE_DATA_LOAD_FAILURE =
  'ENTER_PAYMENT_PAGE_DATA_LOAD_FAILURE';

export interface SubmitPaymentStartAction {
  type: 'SUBMIT_PAYMENT_START';
}

export interface SubmitPaymentFailureAction {
  type: 'SUBMIT_PAYMENT_FAILURE';
  error: string;
}

export interface PaymentMethodSelected {
  type: 'PAYMENT_METHOD_SELECTED';
  paymentMethod: string;
  errorMessage: string;
}

export type PaymentAction =
  | SubmitPaymentStartAction
  | SubmitPaymentFailureAction
  | PaymentMethodSelected;
